// extracted by mini-css-extract-plugin
export default {"container":"date-summary_container__34BK0","date":"date-summary_date__2VpST","day":"date-summary_day__3WAG4","month":"date-summary_month__Kiegy"};